import { Avatar } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Stepper from '@material-ui/core/Stepper';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { AppConfig } from '../../../../config/app';
import { DataApi } from '../../../../providers/api-provider';
import { StoreSubscribe } from '../../../../providers/global-store-provider';
import { handleInputState, Loader, showError, showSuccess } from '../../libs/helpers';
/* import InstitutionBillingInfoDreamInfo from './InstitutionBillingInfoDreamInfo'; */
import styles from '../styles/register';
import InstitutionBankInfo from './InstitutionBankInfo';
import InstitutionExtraInfo from './InstitutionExtraInfo';
import InstitutionRecipientInfo from './InstitutionRecipientInfo';



const steps = ['Bank Information', 'Institution Information', 'Extra Information'];


//InstitutionBillingInfo or Complete Profile
class InstitutionBillingInfo extends React.Component {

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  state = {
    activeStep: 0,
    loading: false,
    fetchLoading: false,
    done: false,
    fetchError: false,
    institution: { name: '' },
    form: {
      bank_name: '',
      bank_swift_bic: '',
      bank_address: '',
      bank_city: '',
      bank_postal_code: '',
      bank_country_id: '',
      main_currency: '',
      bank_phone_number: '',
      branch_phone_number: '',
      branch_bank_name: '',
      branch_bank_swift_bic: '',
      short_code: '',
      recipient_account_number: '',
      message_to_recipient_bank: '',
      recipient_name: '',
      recipient_nickname: '',
      recipient_address: '',
      recipient_city: '',
      recipient_country_id: '',
      recipient_region: '',
      recipient_postal_code: '',
      message_to_recipient: '',
      recipient_phone_number: '',
      comments: '',
    },
    errors: {
      bank_name: false,
      bank_swift_bic: false,
      bank_address: false,
      bank_city: false,
      bank_postal_code: false,
      bank_country_id: false,
      bank_phone_number: false,
      main_currency: false,
      recipient_account_number: false,
      recipient_name: false,
    },
    stepErrors: {
      bank_name: 0,
      bank_swift_bic: 0,
      bank_address: 0,
      bank_city: 0,
      bank_postal_code: 0,
      bank_country_id: 0,
      main_currency: 0,
      bank_phone_number: 0,
      recipient_account_number: 1,
      message_to_recipient_bank: 1,
      recipient_name: 1,
      recipient_address: 1,
      recipient_city: 1,
      recipient_country_id: 1,
      recipient_region: 1,
      recipient_postal_code: 1,
      message_to_recipient: 1,
      recipient_phone_number: 1,

    }
  };
  /*
  -----------------------------------------------------------------------
  API Functions
  -----------------------------------------------------------------------
  */
  /* API Call */
  performInstitutionBillingInfoAction = async (store) => {
    if (this.checkErrors()) {
      let data = this.state.form;
      this.setState({ loading: true });
      data.role = 'student';
      //InstitutionBillingInfo
      let res = await DataApi.update('institutions/' + this.props.match.params.maskedId + '/bank-info', data);
      try {
        //Show SnackBar
        showSuccess('Thank you', 'success');
        this.setState({ loading: false, done: true, });
      } catch (error) {
        let newState = this.state;
        let navigateTo = false;
        //Show SnackBar
        showError(error);
        if (typeof (error.response) !== 'undefined' && typeof (error.response.data.errors) !== 'undefined') {
          for (let field in this.state.errors) {
            if (typeof (error.response.data.errors[field]) !== "undefined") {
              newState.errors[field] = error.response.data.errors[field][0];
              //prepare navigate to first error step fragment
              if (!navigateTo)
                navigateTo = field;
            } else
              newState.errors[field] = false;
          }
          newState.errors.enabled = true;
        }
        newState.loading = false;
        this.setState(newState, () => {
          //Navigate To Screen
          if (navigateTo)
            this.handleGoToStep(this.state.stepErrors[navigateTo]);
        });
        this.setState(newState);
      }

    }

  }
  fetchInstitutionInformationData = async () => {
    this.setState({ fetchLoading: true });
    try {
      let res = await DataApi.getOne('institutions/' + this.props.match.params.maskedId + '/bank-info');
      this.setState({ institution: res.data, fetchLoading: false });
    } catch (e) {
      showError(e);
      this.setState({ fetchError: true, fetchLoading: false });
    }

  }
  componentDidMount() {
    this.fetchInstitutionInformationData();
  }
  /*
 -----------------------------------------------------------------------
 RENDER Functions
 -----------------------------------------------------------------------
 */

  getStepContent(step) {
    switch (step) {
      case 0:
        return <InstitutionBankInfo onChange={this.onChange} form={this.state.form} errors={this.state.errors} />;
      case 1:
        return <InstitutionRecipientInfo onChange={this.onChange} form={this.state.form} errors={this.state.errors} />;
      case 2:
        return <InstitutionExtraInfo onChange={this.onChange} form={this.state.form} errors={this.state.errors} />;
      default:
        throw new Error('Unknown step');
    }
  }


  handleNext = (store) => {
    if (true/* this.checkErrors() */) {
      if (this.state.activeStep === 2) {
        this.performInstitutionBillingInfoAction(store);
      }
      else {
        this.setState(state => ({
          activeStep: state.activeStep + 1,
        }));
      }
    }
  };
  handleBack = () => {
    this.setState(state => ({
      activeStep: state.activeStep - 1,
    }));
  };

  handleReset = () => {
    this.setState({
      activeStep: 0,
    });
  };
  handleGoToStep = (step) => {
    this.setState({
      activeStep: step,
    });
  };
  /* Validate Form */
  checkErrors = () => {
    if (this.state.form.branch_bank_name && !this.state.form.branch_bank_swift_bic) {
      showError('Fill the Swift/BIC for branch bank please')
      return false;
    }
    let errors = { enabled: false };
    let stepErrors = this.state.stepErrors;
    let navigateTo = false;
    for (let field in this.state.errors) {
      if (field === 'enabled') continue;
      errors[field] = this.state.form[field] === '' || this.state.form[field] === null;
      if (errors[field]) {
        errors.enabled = true;
        //prepare navigate to first error step fragment
        if (!navigateTo)
          navigateTo = field;
      }
    }
    //Navigate To Screen
    if (navigateTo)
      this.handleGoToStep(stepErrors[navigateTo]);
    this.setState({
      errors: errors,
    });
    return !errors.enabled;
  }
  /* Hanle State Management of form */
  onChange = handleInputState
  renderLoadingFetchInformation() {
    return (
      <div>
        <Loader size='40' />
        <Typography variant="body1" align='center' style={{ width: '100%' }}>
          Loading Institution
        </Typography>
      </div>
    );
  }
  renderForm() {
    const { classes } = this.props;
    const { activeStep, loading, institution } = this.state;
    return (
      <div>
        <Typography variant="h5" style={{ width: '100%' }}>
          Please Fill <Typography variant="h5" color='primary' inline>{institution.name}</Typography> Bank Information
            </Typography>
        <Stepper activeStep={activeStep} className={classes.stepper}>
          {steps.map(label => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        <React.Fragment>
          <React.Fragment>
            {this.getStepContent(activeStep, this.onChange)}

            <div className={classes.buttons}>
              {activeStep !== 0 && (
                <Button onClick={this.handleBack} className={classes.button}>
                  Back
                  </Button>
              )}
              <StoreSubscribe>
                {store => (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => this.handleNext(store)}
                    className={classes.button}
                    disabled={loading}
                  >
                    {activeStep === steps.length - 1 ? (loading ? 'Loading...' : 'Save') : 'Next'}
                  </Button>
                )}
              </StoreSubscribe>
            </div>
          </React.Fragment>

        </React.Fragment>
      </div>
    )
  }
  renderFetchError() {
    return (
      <div>
        <Typography variant="body1" align='center' style={{ width: '100%' }}>
          Institution does not exists or bank data already filled!
          </Typography>
        <Typography variant="body1" align='center' style={{ width: '100%' }}>
          <a href="https://www.edseed.me">Go to edSeed.me</a>
        </Typography>
      </div>
    );
  }
  renderDone() {
    return (
      <div>
        <Typography variant="body1" align='center' style={{ width: '100%' }}>
          Bank data submitted Thank you!
          </Typography>
        <Typography variant="body1" align='center' style={{ width: '100%' }}>
          <a href="https://www.edseed.me">Go to edSeed.me</a>
        </Typography>
      </div>
    );
  }
  render() {
    const { classes } = this.props;
    const { fetchLoading, fetchError, done } = this.state;

    return (

      <main className={classes.layout}>
        <Paper className={classes.paper} style={{ backgroundColor: '#ffffffe6' }}>
          <Avatar className={classes.avatar}>
            <img alt='edSeed Logo' src={AppConfig.base + '/logo.png?v1'} style={{ width: '95%' }} />
          </Avatar>
          {fetchLoading ? this.renderLoadingFetchInformation() :
            (fetchError ? this.renderFetchError() :
              (done ? this.renderDone() : this.renderForm()))
          }
        </Paper>
      </main>

    );
  }
}

InstitutionBillingInfo.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withRouter(InstitutionBillingInfo));